import script from "./DemoView.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoView.vue?vue&type=script&setup=true&lang=js"

import "./DemoView.vue?vue&type=style&index=0&id=21b2dc22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b2dc22"]])

export default __exports__